/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsUserDeviceListItem,
    MelcoModelsUserDeviceListItemFromJSON,
    MelcoModelsUserDeviceListItemFromJSONTyped,
    MelcoModelsUserDeviceListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsUserDeviceListItem
 */
export interface MelcoModelsGenericList1MelcoModelsUserDeviceListItem {
    /**
     * 
     * @type {Array<MelcoModelsUserDeviceListItem>}
     * @memberof MelcoModelsGenericList1MelcoModelsUserDeviceListItem
     */
    list: Array<MelcoModelsUserDeviceListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsUserDeviceListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsUserDeviceListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsUserDeviceListItemFromJSON(json: any): MelcoModelsGenericList1MelcoModelsUserDeviceListItem {
    return MelcoModelsGenericList1MelcoModelsUserDeviceListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsUserDeviceListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsUserDeviceListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsUserDeviceListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsUserDeviceListItemToJSON(value?: MelcoModelsGenericList1MelcoModelsUserDeviceListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsUserDeviceListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


